import { IconProps } from './Icon.types';

export const ChevronDownIcon = ({
  fill = '#000',
  size = 24,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.59 8.29492L12 12.8749L7.41 8.29492L6 9.70492L12 15.7049L18 9.70492L16.59 8.29492Z"
      fill={fill}
    />
  </svg>
);
